import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import apiClient from "../../utils/apiClient";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../components/ui/tabs";

import AlphaIndiaTables from "./AlphaIndiaTables";
import AlphaUSTable from "./AlphaUSTables";
import server from "../../utils/serverConfig";

export default function AlphaScreener() {
  const [dataAlpha50, setDataAlpha50] = useState({});
  const [dataAlpha100, setDataAlpha100] = useState({});
  const [dataAlpha200, setDataAlpha200] = useState({});
  const [dataAlpha500, setDataAlpha500] = useState({});
  // const [dataAlphaNDX, setDataAlphaNDX] = useState({});
  const [dataAlphaSPX, setDataAlphaSPX] = useState({});
  const [dataAlphaRussell1000, setDataAlphaRussell1000] = useState({});
  const [dataAlphaRussell2000, setDataAlphaRussell2000] = useState({});

  const fetchAlphaScreener = () => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}get-alpha-screener-data`,
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response data-------------->", response.data);

        const data = response.data;

        if (data["Alpha_nifty_50"]) {
          setDataAlpha50({ "Alpha 50": data["Alpha_nifty_50"] });
        }
        if (data["Alpha_nifty_100"]) {
          console.log("Alpha_nifty_100", data["Alpha_nifty_100"]);
          setDataAlpha100({ "Alpha 100": data["Alpha_nifty_100"] });
        }
        if (data["Alpha_nifty_200"]) {
          setDataAlpha200({ "Alpha 200": data["Alpha_nifty_200"] });
        }
        if (data["Alpha_nifty_500"]) {
          setDataAlpha500({ "Alpha 500": data["Alpha_nifty_500"] });
        }
        // if (data["Alpha_nasdaq_100"]) {
        //   setDataAlphaNDX({ "Alpha NDX": data["Alpha_nasdaq_100"] });
        // }
        if (data["Alpha_snp_500"]) {
          setDataAlphaSPX({ "Alpha SNP": data["Alpha_snp_500"] });
        }
        if (data["Alpha_russell_1000"]) {
          setDataAlphaRussell1000({
            "Alpha Russell 1000": data["Alpha_russell_1000"],
          });
        }
        if (data["Alpha_russell_2000_1"]) {
          setDataAlphaRussell2000({
            "Alpha Russell 2000": data["Alpha_russell_2000_1"],
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [indexData, setIndexData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [alphaScreenerData, setAlphaScreenerData] = useState([]);
  const [alphaLoading, setAlphaLoading] = useState(true);

  const [indexColorCodeData, setIndexColorCodeData] = useState([]);

  // Fetch index data from the API
  const fetchIndexData = async () => {
    try {
      const response = await apiClient.get(`${server.godseye.baseUrl}get-index-data`);
      const data = response.data;

      console.log("API Response:", data);

      // Check if data has the expected structure
      if (data && data.formatted && Array.isArray(data.formatted)) {
        setIndexData(data.formatted);
        console.log("Formatted Data:", data.formatted);
      } else {
        console.error("Unexpected data format:", data);
        setError("Data format error");
      }

      setLoading(false);
      return data.formatted;
    } catch (error) {
      console.error("Error fetching index data:", error);
      setError("Failed to fetch data");
      setLoading(false);
    }
  };

  // Fetch index data from the API
  const fetchIndexDataFromGoogleSheet = async () => {
    try {
      const response = await apiClient.get(
        "https://server.sypto.xyz/sypto/api/get_alpha_screener"
      );
      const data = response.data;
      // Check if data has the expected structure
      if (data) {
        console.log("Alpha screener Data:", data);
        setAlphaScreenerData(data);
      } else {
        console.error("Unexpected data format:", data);
        setError("Data format error");
      }

      setAlphaLoading(false);
      return data;
    } catch (error) {
      console.error("Error fetching index data:", error);
      setAlphaLoading(false);
    }
  };

  const extractMatchingData = async () => {
    const result = [];

    const alpData = await fetchIndexDataFromGoogleSheet();
    const idxData = await fetchIndexData();
    console.log("Index data", idxData);
    console.log("Alpha data", alpData);

    idxData &&
      idxData?.forEach((entry) => {
        const { strategy, zone } = entry;

        if (strategy && zone) {
          const matches = alpData.filter(
            (item) => item.Index === strategy && item.Zone === zone
          );

          matches.forEach((match) => {
            result.push({
              index: match.Index,
              strategy: match.Strategy,
              color_code: match["Color code"],
            });
          });
        }
      });

    console.log("Result data after matching", result);
    setIndexColorCodeData(result);

    return result;
  };

  useEffect(() => {
    fetchAlphaScreener();
    extractMatchingData();
  }, []);

  return (
    <DashboardLayout>
      <div className="w-full ">
        <div className="flex justify-between w-full h-full  ">
          <Tabs defaultValue="alpha-50" className="w-full">
            <div className="flex  justify-center sticky top-0 bg-black px-4 py-2  ">
              <TabsList className="grid  grid-cols-8 w-full ">
                <TabsTrigger className="text-[14px]" value="alpha-50">
                  Alpha 50
                </TabsTrigger>
                <TabsTrigger className="text-[14px]" value="alpha-100">
                  Alpha 100
                </TabsTrigger>
                <TabsTrigger className="text-[14px]" value="alpha-200">
                  Alpha 200
                </TabsTrigger>
                <TabsTrigger className="text-[14px]" value="alpha-500">
                  Alpha 500
                </TabsTrigger>
                <TabsTrigger className="text-[14px]" value="alpha-spx">
                  Alpha SPX
                </TabsTrigger>
                {/* <TabsTrigger className="text-[14px]" value="alpha-ndx">
                  Alpha NDX
                </TabsTrigger> */}
                <TabsTrigger className="text-[14px]" value="alpha-russell-1000">
                  Alpha Russell 1000
                </TabsTrigger>
                <TabsTrigger className="text-[14px]" value="alpha-russell-2000">
                  Alpha Russell 2000
                </TabsTrigger>
              </TabsList>
            </div>

            <TabsContent value="alpha-50" className="">
              <div className=" w-full max-h-[calc(100vh-80px)] max-w-[100vw] overflow-auto">
                <AlphaIndiaTables
                  data={dataAlpha50}
                  loading={loading}
                  error={error}
                  indexData={indexData}
                  indexColorCodeData={indexColorCodeData}
                />
              </div>
            </TabsContent>
            <TabsContent value="alpha-100" className="">
              <div className=" w-full max-h-[calc(100vh-80px)] max-w-[100vw] overflow-auto">
                <AlphaIndiaTables
                  data={dataAlpha100}
                  loading={loading}
                  error={error}
                  indexData={indexData}
                  indexColorCodeData={indexColorCodeData}
                />
              </div>
            </TabsContent>
            <TabsContent value="alpha-200" className="">
              <div className=" w-full max-h-[calc(100vh-80px)] max-w-[100vw] overflow-auto">
                <AlphaIndiaTables
                  data={dataAlpha200}
                  loading={loading}
                  error={error}
                  indexData={indexData}
                  indexColorCodeData={indexColorCodeData}
                />
              </div>
            </TabsContent>
            <TabsContent value="alpha-500" className="">
              <div className=" w-full max-h-[calc(100vh-80px)] max-w-[100vw] overflow-auto">
                <AlphaIndiaTables
                  data={dataAlpha500}
                  loading={loading}
                  error={error}
                  indexData={indexData}
                  indexColorCodeData={indexColorCodeData}
                />
              </div>
            </TabsContent>
            <TabsContent value="alpha-spx" className="">
              <div className=" w-full max-h-[calc(100vh-80px)] max-w-[100vw] overflow-auto">
                <AlphaUSTable
                  data={dataAlphaSPX}
                  loading={loading}
                  error={error}
                  indexData={indexData}
                  indexColorCodeData={indexColorCodeData}
                />
              </div>
            </TabsContent>
            {/* <TabsContent value="alpha-ndx" className="">
              <div className=" w-full max-h-[calc(100vh-80px)] max-w-[100vw] overflow-auto">
                <AlphaUSTable
                  data={dataAlphaNDX}
                  loading={loading}
                  error={error}
                  indexData={indexData}
                  indexColorCodeData={indexColorCodeData}
                />
              </div>
            </TabsContent> */}
            <TabsContent value="alpha-russell-1000" className="">
              <div className=" w-full max-h-[calc(100vh-80px)] max-w-[100vw] overflow-auto">
                <AlphaUSTable
                  data={dataAlphaRussell1000}
                  loading={loading}
                  error={error}
                  indexData={indexData}
                  indexColorCodeData={indexColorCodeData}
                />
              </div>
            </TabsContent>
            <TabsContent value="alpha-russell-2000" className="">
              <div className=" w-full max-h-[calc(100vh-80px)] max-w-[100vw] overflow-auto">
                <AlphaUSTable
                  data={dataAlphaRussell2000}
                  loading={loading}
                  error={error}
                  indexData={indexData}
                  indexColorCodeData={indexColorCodeData}
                />
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </DashboardLayout>
  );
}
